import { Link } from 'react-router-dom';
import { FaInstagram, FaWhatsapp, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Jardins Verticais', path: '/jardins-verticais' },
    { name: 'Paisagismo Permanente', path: '/paisagismo' },
    { name: 'Paisagismo Natural', path: '/paisagismo' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    },
  };

  return (
    <footer className="bg-gradient-to-br from-dark to-dark-lighter text-white">
      {/* Main Footer */}
      <motion.div
        className="section-padding"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            {/* About */}
            <motion.div variants={itemVariants} className="space-y-4">
              <img
                src="/images/logo-transparent.png"
                alt="Arte Verde Jardins"
                className="h-16 w-auto"
              />
              <p className="text-gray-300 leading-relaxed">
              Transforme seu jardim em um paraíso natural! Aqui você encontra tudo o que precisa para criar e manter um espaço verde, exuberante e cheio de vida.
              </p>
              <div className="flex gap-4">
                <a
                  href="https://www.instagram.com/jardimarteverde/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/10 hover:bg-natureza p-3 rounded-full transition-all duration-300 hover:scale-110"
                >
                  <FaInstagram size={20} />
                </a>
                <a
                  href="https://api.whatsapp.com/send?phone=5511940447538"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/10 hover:bg-natureza p-3 rounded-full transition-all duration-300 hover:scale-110"
                >
                  <FaWhatsapp size={20} />
                </a>
              </div>
            </motion.div>

            {/* Services */}
            <motion.div variants={itemVariants} className="space-y-4">
              <h4 className="text-xl font-bold text-natureza">Serviços</h4>
              <ul className="space-y-2">
                {services.map((service) => (
                  <li key={service.name}>
                    <Link
                      to={service.path}
                      className="text-gray-300 hover:text-natureza transition-colors duration-300 flex items-center gap-2 group"
                    >
                      <span className="w-0 h-0.5 bg-natureza transition-all duration-300 group-hover:w-4" />
                      {service.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Contact Info */}
            <motion.div variants={itemVariants} className="space-y-4">
              <h4 className="text-xl font-bold text-natureza">Contato</h4>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start gap-3">
                  <FaPhone className="mt-1 text-natureza flex-shrink-0" size={16} />
                  <a
                    href="tel:11940447538"
                    className="hover:text-natureza transition-colors"
                  >
                    (11) 94044-7538
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <FaEnvelope className="mt-1 text-natureza flex-shrink-0" size={16} />
                  <a
                    href="mailto:contatoarteverdejardins@gmail.com"
                    className="hover:text-natureza transition-colors break-all"
                  >
                    contatoarteverdejardins@gmail.com
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <FaMapMarkerAlt className="mt-1 text-natureza flex-shrink-0" size={16} />
                  <span>
                    R. Cap. Júlio Alfredo Montes, 42<br />
                    Vila São José - São Paulo/SP
                  </span>
                </li>
              </ul>
            </motion.div>

            {/* Map */}
            <motion.div variants={itemVariants} className="space-y-4">
              <h4 className="text-xl font-bold text-natureza">Localização</h4>
              <div className="rounded-lg overflow-hidden shadow-lg h-48">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.3859817787966!2d-46.61867678449331!3d-23.59048636855472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5bc346b0d92d%3A0xeaf24f89b14043ba!2sR.%20Cap.%20J%C3%BAlio%20Alfredo%20Montes%2C%2042%20-%20Vila%20S%C3%A3o%20Jos%C3%A9%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2004271-040!5e0!3m2!1spt-BR!2sbr!4v1680661964463!5m2!1spt-BR!2sbr"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Localização Arte Verde Jardins"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-6">
        <div className="container-custom">
          <div className="text-center text-gray-400 text-sm">
            <p>
              &copy; {currentYear} Arte Verde Jardins. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
